/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PaymentConfiguration = {
    collectPaymentsSince: string | null;
    recipientName: string | null;
    automaticPaymentRequestsEnabled: boolean;
    paymentDueDays: number;
    enabledPaymentTypes: Array<'online' | 'cash' | 'invoice'>;
    onlineProviderType: PaymentConfiguration.onlineProviderType | null;
    onlineAccountSetupCompleted: boolean;
    onlineAccountId: string | null;
    onlineAccountUsername: string | null;
    enabledOnlinePaymentMethods: Array<'card' | 'sepa' | 'paypal' | 'klarna' | 'bank_transfer' | 'apple_pay' | 'google_pay'>;
    availableOnlinePaymentMethods: Array<'card' | 'sepa' | 'paypal' | 'klarna' | 'bank_transfer' | 'apple_pay' | 'google_pay'>;
    iban: string | null;
    bic: string | null;
    bankName: string | null;
    metadata: Record<string, any>;
};
export namespace PaymentConfiguration {
    export enum onlineProviderType {
        PAYPAL = 'paypal',
        STRIPE = 'stripe',
    }
}

